import { Card } from "@/components/ui/card";

export function ProductCardSkeleton() {
  return (
    <Card className="p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <div className="h-5 w-32 bg-muted animate-pulse rounded" />
            <div className="h-5 w-16 bg-muted animate-pulse rounded" />
          </div>
          <div className="h-6 w-24 bg-muted animate-pulse rounded mt-2" />
          <div className="h-4 w-16 bg-muted animate-pulse rounded mt-1" />
        </div>
      </div>
    </Card>
  );
}

export function TransactionItemSkeleton() {
  return (
    <div className="flex items-center gap-3 py-3 border-b border-border last:border-0">
      <div className="flex-shrink-0 p-2 rounded-full bg-muted h-10 w-10 animate-pulse" />
      <div className="flex-1">
        <div className="h-5 w-32 bg-muted animate-pulse rounded" />
        <div className="h-4 w-24 bg-muted animate-pulse rounded mt-1" />
      </div>
      <div className="text-right">
        <div className="h-5 w-20 bg-muted animate-pulse rounded" />
        <div className="h-3 w-16 bg-muted animate-pulse rounded mt-1" />
      </div>
    </div>
  );
}

export function StatCardSkeleton() {
  return (
    <Card className="flex-1 min-w-[140px]">
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1">
            <div className="h-4 w-16 bg-muted animate-pulse rounded" />
            <div className="h-7 w-24 bg-muted animate-pulse rounded mt-1" />
          </div>
          <div className="flex-shrink-0 p-2 bg-muted rounded-md h-9 w-9 animate-pulse" />
        </div>
      </div>
    </Card>
  );
}
